import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { findAdesaoByLastFiveDays, findAdesaoByAnoLetivo } from "./api-engajamento-diario";
import EngajamentoChart, {
  PERIODO_ANO_LETIVO,
  PERIODO_CINCO_DIAS,
  SERIES_COLORS,
} from "./EngajamentoChart";

const FETCHERS = {
  [PERIODO_CINCO_DIAS]: findAdesaoByLastFiveDays,
  [PERIODO_ANO_LETIVO]: findAdesaoByAnoLetivo,
};

const GRUPOS = [
  { value: "todos", label: "Responsáveis e alunos", total: "listaTotalRespAluno", adesao: "listaAdesaoRespAluno" },
  { value: "responsaveis", label: "Responsáveis", total: "listaTotalResp", adesao: "listaAdesaoResp" },
  { value: "alunos", label: "Alunos", total: "listaTotalAluno", adesao: "listaAdesaoAluno" },
];

const ultimo = (lista) => (lista && lista.length > 0 ? lista[lista.length - 1] : 0);

const percentual = (parte, total) => (total > 0 ? `${Math.round((parte / total) * 100)}%` : "-");

export default function Adesao() {
  const [grupo, setGrupo] = useState("todos");
  const grupoSelecionado = GRUPOS.find((g) => g.value === grupo);

  const getSeries = (data) => [
    { label: "Total", data: data[grupoSelecionado.total] ?? [], color: SERIES_COLORS.referencia },
    { label: "Adesão", data: data[grupoSelecionado.adesao] ?? [], color: SERIES_COLORS.azul },
  ];

  // Um indicador por grupo com a adesão no dia mais recente.
  const getStats = (data) => {
    const dia = ultimo(data.listaAxeX);
    return GRUPOS.map((g) => {
      const total = ultimo(data[g.total]);
      const adesao = ultimo(data[g.adesao]);
      return { label: g.label, value: percentual(adesao, total), caption: `${adesao} de ${total} em ${dia}` };
    });
  };

  return (
    <EngajamentoChart
      title="Adesão"
      description="Total de responsáveis e alunos e quantos aderiram ao sistema."
      fetchers={FETCHERS}
      getSeries={getSeries}
      getStats={getStats}
      toolbar={
        <TextField
          select
          size="small"
          value={grupo}
          onChange={(event) => setGrupo(event.target.value)}
          aria-label="Grupo do gráfico"
          sx={{ minWidth: 180 }}
        >
          {GRUPOS.map((g) => (
            <MenuItem key={g.value} value={g.value}>
              {g.label}
            </MenuItem>
          ))}
        </TextField>
      }
    />
  );
}
